// extracted by mini-css-extract-plugin
module.exports = {"container":"TextIcon_container__27eTS","iconState":"TextIcon_iconState__3ORG2","label":"TextIcon_label__1gXls","fontIcon":"TextIcon_fontIcon__1j407"};